import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';      

import FinancesDashboard from '../Components/FinancesDashboard';
import Site from '../Components/Site';

import FinancesSupplierAccounts from '../Components/FinancesSupplierAccounts';

import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper'; 




import Button from '@material-ui/core/Button';
import {logout} from '../Actions/AuthActions';



import { FetchSliders,AddSlider,UpdateSlider,DeleteSlider } from '../Actions/SettingsAction';

import { compose } from 'redux';
import { connect } from 'react-redux';

import EditSlide from './EditSlide';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
});



const mapStateToProps = (state) => {
    return {
        loading : state.Common.loading,
        loggedIn : state.Auth.loggedIn,
        slides: state.Common.sliders,
    }
}
const mapDispatchToProps = dispatch => ({
  FetchSliders: () => dispatch(FetchSliders()),
  AddSlider:(data)=>dispatch(AddSlider(data))
});

class Sliders extends React.Component {


    constructor(props){
      super(props);
  
      this.state={
        value: 'one',
        sliderTitle:"",
        sliderSubText:"",
      }
  
      this.props.FetchSliders();
    
    }
  
    
    handleView = (data) => {
      this.props.ViewRefund(data);
    }
  
    handleChange = (event, value) => {
      this.setState({ value });
    };
  
    getRefundStatus(status){        
      switch(status){
      case 0 :{ return "Pending" }
      case 1:{ return "Accepted" }
      case 2 :{ return "Rejected" }
      case 3 :{ return "Completed" }    
      }
    }
  
    getPaymentStatus(status){        
      switch(status){
      case 0 :{ return "Pending" }
      case 1:{ return "Completed" }        
      }
    }


    handleNewSliderText = (e,field) => {
      this.setState({
        [field]:e.target.value
      });
    }

    handleAddCategory = () =>{
        if(this.state.sliderTitle !== null){
            this.props.AddSlider({title:this.state.sliderTitle,sub_text:this.state.sliderSubText});
            this.setState({
              sliderTitle:"",
              sliderSubText:"",
            })
        }
    }
  
    render() {
        const { classes } = this.props;
        const { value } = this.state;
    
     
        
    
        return (
           
            
            
             
                  
            <table className={classes.table}>
          
            <tr>
              <th align="left" style={{width:'10%'}}><p>ID</p></th> 
              <th align="left" style={{width:'15%'}}><p>Image</p></th>   
              <th align="left" style={{width:'20%'}}><p>Title</p></th>           
              <th align="left" style={{width:'20%'}}><p>Sub Text</p></th>                           
              <th align="center"></th>
            </tr>
          
     
          <tr >               
                <td align="left" style={{width:'10%'}}></td>
                <td align="left" style={{width:'15%'}}></td>
                <td align="left" style={{width:'20%'}}>
                  <input type="text" onChange={(e)=>this.handleNewSliderText(e,'sliderTitle')}/>
                </td>
                <td align="left" style={{width:'20%'}}>
                  <input type="text" onChange={(e)=>this.handleNewSliderText(e,'sliderSubText')}/>
                </td>              
                <td align="center">
                <Button onClick={()=>this.handleAddCategory()} size="small" variant="contained" color="primary" style={{background:"#f7a414", textAlign:'center'}} className={classes.button}>
                   <b>Add</b> 
                </Button>
                </td>
              </tr>  
            {this.props.slides.map((row,index) => {
                return <EditSlide row={row}/>

            }
                
            )}

              
               
          
        </table>);
      }
    }
    
    Sliders.propTypes = {
      classes: PropTypes.object.isRequired,
    };
    export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Sliders);
    
